import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-arrival-departure-report',
    templateUrl: './arrival-departure-report.component.html',
    styleUrls: ['./arrival-departure-report.component.css'],
    standalone: false
})
export class ArrivalDepartureReportComponent implements OnInit {

  constructor() { }
  products: any[] = [];

  ngOnInit(): void {
    const data = [{
      name: 'Honua Kai',
      outs: '3',
      ins: '6',
    },
    {
      name: 'Kapalua Bay Villas',
      outs: '1',
      ins: '1',
    },
    {
      name: 'Kapalua Golf Villas',
      outs: '2',
      ins: '3',
    },
    {
      name: 'Kapalua Ridge Villas',
      outs: '1',
      ins: '0',
    },
    {
      name: 'Polo Beach Club',
      outs: '1',
      ins: '1',
    },
    {
      name: 'Valley Isle Resort',
      outs: '1',
      ins: '0',
    },
    {
      name: 'International Colony Club',
      outs: '0',
      ins: '1',
    },
    {
      name: 'Kamaole Sands',
      outs: '0',
      ins: '1',
    },
    {
      name: 'Maalaea Surf',
      outs: '1',
      ins: '0',
    },
    {
      name: 'Total',
      outs: '10',
      ins: '13',
    },
  ];
    this.products = data;
  }

}
